import moment from "moment/moment";
import React from "react";

const ReviewInformation = ({ details, payment_amount }) => {
  return (
    <div>
      <div className='row'>
        <div className='col-md-10'>
          <div className='row'>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Policy No: </span>
              <span>{details?.policyAppNumber}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Policy Name: </span>
              <span>{details?.policyName}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Status: </span>
              <span className='badge badge-success-lighten'>
                {details?.status === "2" && "Active"}
              </span>
              <span className='badge badge-warning-lighten'>
                {details?.status === "1" && "Pending"}
              </span>
              <span className='badge badge-info-lighten'>
                {(details?.status === "3" || details?.status === undefined) &&
                  "Matured"}
              </span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Sub-Status: </span>
              {details?.totalPremium > payment_amount &&
                payment_amount !== 0 && (
                  <>
                    <span className='badge badge-warning-lighten'>
                      Partial payment
                    </span>
                  </>
                )}
              {payment_amount === 0 && (
                <>
                  <span className='badge badge-danger-lighten'>
                    No payment yet
                  </span>
                </>
              )}
              {parseFloat(details?.totalPremium) ===
                parseFloat(payment_amount) && (
                <span className='badge badge-success-lighten'>Fully Paid</span>
              )}
              {details?.totalPremium < payment_amount && (
                <>
                  <span className='badge badge-info-lighten'>Overpaid</span>
                  {/* <span> &#8358;{payment_amount}</span> */}
                </>
              )}
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Duration: </span>
              <span>{details?.duration} months</span>
            </div>
            {details?.discount && (
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Discount: </span>
                <span> {details?.discount}%</span>
              </div>
            )}
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Effective Date: </span>
              <span>{moment(details?.effectiveDate).format("LL")}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>End Date: </span>
              <span>{moment(details?.endDate).format("LL")}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Approval Date: </span>
              <span>
                {details?.policy_app_approval_date === "NULL"
                  ? "Policy yet to be approved"
                  : moment(details?.policy_app_approval_date).format("LL")}
              </span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Total Premium: </span>
              <span>&#8358;{parseFloat(details?.totalPremium).toFixed(2)}</span>
            </div>
            {details?.butCharge ? (
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>But-Charge: </span>
                <span> &#8358;{parseInt(details?.butCharge)}</span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewInformation;
